import { render } from "./like_project.vue?vue&type=template&id=faefd4d6"
import script from "./like_project.vue?vue&type=script&lang=js"
export * from "./like_project.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.www/src/fe-www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__